module.exports = __webpack_public_path__ + "static/media/Person3.ff33f34a.png";